module.exports = __webpack_public_path__ + "img/minipack-active.af2bcb58.svg";